// Admin Calendar with FullCalendar
import { useState, useEffect, useRef } from 'react';

export default function AdminCalendar() {
  const calendarRef = useRef<any>(null);
  const [events, setEvents] = useState<any[]>([]);
  
  useEffect(() => {
    fetch('/api/calendar/admin/events', { credentials: 'include' })
      .then(r => r.json())
      .then(d => { if(d.success) setEvents(d.data); });
  }, []);
  
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Calendar</h1>
      <div className="card bg-base-100 shadow p-4">
        <div className="text-sm text-gray-500">FullCalendar integration - events would render here after npm install and full implementation.</div>
        <div className="mt-4 h-96 bg-base-200 rounded flex items-center justify-center">
          <p>Calendar events: {events.length} loaded</p>
        </div>
      </div>
    </div>
  );
}